// extracted by mini-css-extract-plugin
module.exports = {"mobileToolbar":"ProductsLoader_mobileToolbar___gI_1"};